import * as bootstrap from "bootstrap";

export function initSheetSubmissionModal(root = document) {
  const modalEl = root.querySelector("#sheet-send-confirm-modal");
  if (!(modalEl instanceof HTMLElement)) {
    return;
  }

  const formEl = modalEl.querySelector("[data-sheet-send-form]");
  const titleEl = modalEl.querySelector("#sheet-send-confirm-modal-title");
  const messageEl = modalEl.querySelector("[data-sheet-send-message]");
  const nameWrapEl = modalEl.querySelector("[data-sheet-send-name-wrap]");
  const nameEl = modalEl.querySelector("[data-sheet-send-name]");

  if (!(formEl instanceof HTMLFormElement)) {
    return;
  }

  const modal = bootstrap.Modal.getOrCreateInstance(modalEl);

  document.addEventListener("click", (event) => {
    const trigger =
      event.target instanceof Element ? event.target.closest("[data-sheet-action='send-for-acceptance']") : null;

    if (!(trigger instanceof HTMLElement)) {
      return;
    }

    event.preventDefault();

    const submitUrl = String(trigger.dataset.sheetSubmitUrl || "").trim();
    if (!submitUrl) {
      return;
    }

    const modalTitle = String(trigger.dataset.sheetModalTitle || "Wyślij arkusz").trim();
    const modalMessage = String(trigger.dataset.sheetModalMessage || "Czy na pewno wysłać ten arkusz?").trim();
    const sheetName = String(trigger.dataset.sheetName || "").trim();

    formEl.action = submitUrl;

    if (titleEl instanceof HTMLElement) {
      titleEl.textContent = modalTitle;
    }

    if (messageEl instanceof HTMLElement) {
      messageEl.textContent = modalMessage;
    }

    if (nameWrapEl instanceof HTMLElement && nameEl instanceof HTMLElement) {
      if (sheetName !== "") {
        nameEl.textContent = sheetName;
        nameWrapEl.hidden = false;
      } else {
        nameEl.textContent = "";
        nameWrapEl.hidden = true;
      }
    }

    modal.show();
  });
}
